import React from 'react';
import { Link } from 'react-router-dom';
import { useForm, ValidationError } from '@formspree/react';

import Nav from '../components/Nav';
import MyPhoto from '../image/myphoto.png';
import ResponsiveNav from '../components/ResponsiveNav';
import WavingSVG from '../components/waveSvg/WavingSvg';

const Contact = () => {
  const [state, handleSubmit] = useForm("mleyrkzj");

  if (state.succeeded) {
    return (
      <div className='w-full h-auto lg:h-[500px] flex flex-col justify-center items-center gap-5 p-10 text-xl'>
        <div>
          <img
            src={MyPhoto}
            alt='Feruz Teame'
            className='
              w-[100px]
              h-[100px]
              text-center
              rounded-full
              drop-shadow-[0_0_20px_black]
              border-double border-4 border-[#858585]
              cursor-grab
            '
          />
        </div>
        <p className='text-2xl'>Hey! 😊 Thanks for Contact me.</p>
        <p className='text-lg text-center text-neutral-500'>Your email has been sent successfully and Thank you for your interest.</p>
        <p className='text-lg text-center text-neutral-500'>I will back to you soon.</p>
        <Link to="/" className="hover:underline decoration-[#29819a] decoration-2 text-lg text-[#29819a] "> Back to website</Link>
      </div>
    );
  }

  return (
    <div className='flex flex-col lg:flex-row justify-center gap-20 lg:gap-0 font-[Vintage]'>
      <Nav />
      <ResponsiveNav />
      <div className="flex flex-col justify-center items-center w-full gap-10">
        <p className="text-2xl font-bold text-center text-[#29819a]">Get In Touch</p>
        <p className='text-center text-lg  px-6 lg:px-[20%]'>
          Ready to unlock your potential? Contact me now for a transformative journey to success.
          Let's start achieving your goals together!
        </p>
        <div className='flex flex-col lg:flex-row justify-center items-center lg:border-double lg:border-4 border-[#29819a] w-full lg:w-[60%] rounded'>
          <div className='hidden lg:flex justify-end w-[50%] h-full'>
            <img src={MyPhoto} alt='Feruz Teame' />
          </div>
          <form onSubmit={handleSubmit} className="w-[100%] lg:w-[60%] md:w-[80%] p-10 self-end md:self-center">
            <div className="mb-4">
              <div className='flex gap-2 items-end'>
                <label htmlFor="name" className="">Name</label>
              </div>
              <input required type="text" id="name" name="name" className="w-full border-b-2 border-[#858585] px-3 py-2 focus:outline-none bg-transparent" />
              <ValidationError 
                prefix="name"
                field="name"
                errors={state.name}
              />
            </div>
            <div className="mb-4">
              <div className='flex gap-2 items-end'>
                <label htmlFor="email" className="">Email</label>
              </div>
              <input required type="email" id="email" name="email" className="w-full border-b-2 border-[#858585] px-3 py-2 focus:outline-none bg-transparent" />
              <ValidationError 
                prefix="Email" 
                field="email"
                errors={state.errors}
              />
            </div>
            <div className="mb-4">
              <div className='flex gap-2 items-end'>
                <label htmlFor="message" className="">Message</label>
              </div>
              <textArea required type="message" id="message" name="message" className="h-[100px] w-full border-b-2 border-[#858585] px-3 py-2 focus:outline-none bg-transparent" />
              <ValidationError 
                prefix="Message" 
                field="message"
                errors={state.errors}
              />
            </div>
            <div className='flex justify-between items-end my-16 lg:m-0'>
              <button type="submit" value="Submit" className="bg-[#29829ab6] text-white py-2 px-4 rounded hover:bg-[#29819a] cursor-pointer">
                <div className='flex gap-2'>
                  <p className='text-black'>Send</p>
                </div>
              </button>
              <a href='mailto:teamefitwi@gmail.com' target='_blank' rel="noreferrer" className='cursor-pointer hover:text-[#29819a] hover:underline'>Use your email app</a>
            </div>
          </form>
        </div>
      </div>
      <WavingSVG />
    </div>
  );
};

export default Contact;
